'use client';
// 在自定义 Hook 或组件中
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect} from 'react';
import { pageview } from '@/lib/gtag';

export default function GAListener() {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        if (process.env.NODE_ENV !== 'production') return; 

        const url = pathname + searchParams.toString();
        pageview(url);
    }, [pathname, searchParams]);

    return null; // 无需渲染任何UI
}